/**
 * Étiquettes des graduations d'un repère orthogonal (rendu élève interactif,
 * aperçu prof, impression) : facteur de taille par graduation, 0 = pas
 * d'étiquette.
 *
 * Pas 0,5 ou 0,25 (repérage 4e, gen 1114) : seuls les entiers sont
 * étiquetés (sinon « -0,5 » et « 0,5 » se chevauchent autour de l'origine,
 * et « -3,5 », « -2 », « -0,5 » n'aident personne).
 * Autres pas : au plus ~9 étiquettes réparties régulièrement (comportement
 * historique, inchangé).
 *
 * @param {number[]} grads     graduations (valeurs)
 * @param {number}   step      pas
 * @param {number}   min, max  bornes de l'axe
 * @param {number}   pxParUnite  pixels (unités du viewBox) pour une unité (réservé)
 * @param {number}   ecartMini   espace minimal entre deux étiquettes (réservé)
 * @returns {number[]} facteur de taille pour chaque graduation (1 ou 0)
 */
export const planEtiquettes = (grads, step, min, max, pxParUnite, ecartMini) => {
    const decimal = Math.abs(step - 0.5) < 1e-9 || Math.abs(step - 0.25) < 1e-9;
    if (!decimal) {
        const every = Math.max(1, Math.ceil((grads.length - 1) / 9));
        return grads.map((v, i) => (i % every === 0 ? 1 : 0));
    }
    // pas décimal : seuls les entiers sont étiquetés (une graduation sur deux en pas 0,5, une sur quatre en pas 0,25),
    // donc rien autour de l'origine avant 1 et −1 (prof, 2026-09-10)
    const nbEntiers = Math.floor(max) - Math.ceil(min) + 1;
    const m = Math.max(1, Math.ceil(nbEntiers / 11));
    // et pas de « 0 » à l'origine non plus (prof, 2026-09-10)
    return grads.map((v) => (Math.abs(v) > 1e-9 && Math.abs(v - Math.round(v)) < 1e-9 && Math.round(v) % m === 0 ? 1 : 0));
};
